module.exports = __webpack_public_path__ + "static/media/google-play-badge_en.857f7293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/google-play-badge_en.png
// module id = 270
// module chunks = 21